import { chassis } from "tbme/localState";
import { ProfileContext } from "../types";

/**
 * Set chassis context from digital-profile chassis
 */
export const setChassisState = ({ chassis: context }: ProfileContext) => {
  if (!context) return;
  chassis(context);
};
